import React, { FC } from 'react';

import { useLang } from 'hooks';
import { Key } from 'components/icons';
import { InputProps } from 'types/components';

import Input from '.';

const PasswordInput: FC<InputProps> = ({
  type = 'password',
  placeholder,
  prefix = <Key />,
  ...props
}) => {
  const lang = useLang();

  return (
    <Input
      type={type}
      placeholder={placeholder ?? lang.get('common.form.password.placeholder')}
      prefix={prefix}
      {...props}
    />
  );
};

export default PasswordInput;
